import { useEffect } from 'react';
import Wrapper from './Wrapper';
import {useSocketContext} from './Provider';

const SocketWrapper = Wrapper;
export default SocketWrapper;

const useSocketListener = (sub, handler) => {
    // Somehow the context isn't available occasionally?!
    const socketContext = useSocketContext();

    useEffect(() => {
        if (!sub || !socketContext) {
            return;
        }

        // We don't want to subscribe to entities without an ID
        if (sub.entity?.entityModel && !sub.entity?.entityId) {
            return;
        }

        const unsubscribe = socketContext.subscribe(sub, handler);

        return unsubscribe;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(sub)]);
}


const useSocketRecipient = (topic) => {
    const {getRecipient} = useSocketContext();

    return getRecipient(topic);
}


export {
    useSocketContext as useSocket,
    useSocketListener,
    useSocketRecipient,
}
